module.exports = __webpack_public_path__ + "0537f965c2c7d39925c0a023eef014b7.png";